export default "__VITE_ASSET__lQVe1rlF__"